<template>
    <select  name="tags[]" class="form-control" multiple="multiple" ref="tags_input"></select>
</template>

<script>
import $ from 'jquery';
import 'select2';

export default {

    data() {
        return {
            client_tags: this.value
        }
    },

    props: {
        value: {
            type: Array,
            default: () => []
        },
    },

    computed: {
        availableTags() {
            return this.$store.getters['clientTags/all'];
        }
    },

    mounted() {
        this.createTagsSelect();

        this.$event_bus.$on('client-tags-selected', (tags) => {
            this.createTagsSelect();

            this.client_tags = tags;

            const tagIds = this.client_tags.map(function (tag) {
                return tag.id;
            });

            $(this.$refs.tags_input).val(tagIds);
            $(this.$refs.tags_input).trigger('change');
        });

        this.$event_bus.$on('client-tags-clear', () => {
            this.client_tags = [];
            $(this.$refs.tags_input).val(null).trigger('change');
        });
    },

    methods: {
        createTagsSelect() {
            const tags_selected_ids = this.client_tags.map(function (tag) {
                return tag.id;
            });

            const data = this.availableTags.map(function (tag) {
                return {
                    id: tag.id,
                    text: tag.name,
                    selected: tags_selected_ids.includes(tag.id)
                }
            });

            $(this.$refs.tags_input).select2({
                data,
                theme: 'bootstrap tags',
                width: 'style',
                tags: true,
                language: {
                    errorLoading: function() {
                        return trans('clients.select_1')
                    },
                    loadingMore: function() {
                        return trans('clients.select_2')
                    },
                    noResults: function() {
                        return trans('clients.select_3')
                    },
                    searching: function() {
                        return trans('clients.select_4')
                    },
                }
            }).on('change', e => {
                this.client_tags = $(this.$refs.tags_input).select2('data');
                this.$emit('input',  this.client_tags );
            });
        }
    }
}
</script>
